import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/manifold-logograph.svg'


const _withScopeId = n => (_pushScopeId("data-v-612cd480"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-claim__media-container" }
const _hoisted_2 = { class: "m-claim__info-container" }
const _hoisted_3 = { class: "m-claim__info-section m-claim__header-information" }
const _hoisted_4 = { class: "m-claim__title" }
const _hoisted_5 = ["data-wallet"]
const _hoisted_6 = { class: "m-claim__info-section m-claim__information" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "m-claim__claim-details__actions"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 1,
  class: "m-claim__claim-details__actions"
}
const _hoisted_12 = { key: 3 }
const _hoisted_13 = {
  key: 1,
  class: "spinner",
  style: {"margin":"0 auto"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "m-giveaway__create-link",
  href: "https://studio.manifold.xyz/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "16",
    height: "16"
  }),
  /*#__PURE__*/_createTextVNode("   Create your own  "),
  /*#__PURE__*/_createElementVNode("span", null, "Manifold Giveaway")
], -1))

import Banner from '@/components/Banner.vue';
import ClaimDescription from '@/components/ClaimDescription.vue';
import Countdown from '@/components/Countdown.vue';
import DisconnectButton from '@/components/DisconnectButton.vue';
import Frame from '@/components/Frame.vue';
import ImageLoader from '@/components/ImageLoader.vue';
import InfoDisplay from '@/components/InfoDisplay.vue';
import JoinButton from '@/components/JoinButton.vue';
import RequirementsSection from '@/components/requirements/RequirementsSection.vue';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimCompleteBody',
  setup(__props) {

const store = useClaimStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Frame, {
    class: _normalizeClass(["m-project m-claim__frame", { portrait: true }]),
    "no-overflow": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ImageLoader, {
          class: "m-claim__media",
          image: _unref(store).image
        }, {
          error: _withCtx(() => [
            _createTextVNode(" Failed to load the image ")
          ]),
          _: 1
        }, 8, ["image"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(store).title), 1),
          _createElementVNode("div", {
            "data-widget": "m-wallet-identity",
            class: "manifold-scheme-dark m-claim__artist-info",
            "data-wallet": _unref(store).creator.address
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(ClaimDescription, {
            description: _unref(store).description
          }, null, 8, ["description"])
        ]),
        (_unref(store).initialized)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(store).status === 'full')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_unref(store).status === 'full')
                      ? (_openBlock(), _createBlock(Banner, {
                          key: 0,
                          emoji: "🤝",
                          title: "The giveaway is closed",
                          description: "The max number of submissions has been reached. Winners will be notified by email."
                        }))
                      : _createCommentVNode("", true),
                    (_unref(store).isLoggedIn)
                      ? (_openBlock(), _createBlock(DisconnectButton, { key: 1 }))
                      : _createCommentVNode("", true)
                  ]))
                : (_unref(store).status === 'not-started')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_unref(store).status === 'not-started')
                        ? (_openBlock(), _createBlock(InfoDisplay, {
                            key: 0,
                            description: "This giveaway is not open yet",
                            type: "info"
                          }))
                        : _createCommentVNode("", true),
                      (!_unref(store)?.signup?.complete)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(RequirementsSection),
                            _createVNode(JoinButton, { class: "m-claim__action-button" })
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_unref(store).status === 'active')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_unref(store).status === 'active' && _unref(store).endDate && !_unref(store).isSoldOut)
                          ? (_openBlock(), _createBlock(Countdown, {
                              key: 0,
                              class: "m-claim__countdown",
                              "end-date": _unref(store).endDate
                            }, null, 8, ["end-date"]))
                          : _createCommentVNode("", true),
                        (!_unref(store)?.signup?.complete)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(RequirementsSection),
                              _createVNode(JoinButton, { class: "m-claim__action-button" })
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(store)?.signup?.complete)
                          ? (_openBlock(), _createBlock(Banner, {
                              key: 2,
                              emoji: "🎉",
                              title: "You're in!",
                              description: "You’ll be notified by the creator if you win the Giveaway"
                            }))
                          : _createCommentVNode("", true),
                        (_unref(store)?.signup?.complete && _unref(store).isLoggedIn)
                          ? (_openBlock(), _createBlock(DisconnectButton, { key: 3 }))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(Banner, {
                          emoji: "🤝",
                          title: "The giveaway has ended",
                          description: "Winners will be notified by the creator"
                        }),
                        (_unref(store).isLoggedIn)
                          ? (_openBlock(), _createBlock(DisconnectButton, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]))
            ], 64))
          : (_openBlock(), _createElementBlock("i", _hoisted_13))
      ]),
      _hoisted_14
    ]),
    _: 1
  }))
}
}

})